<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M9.4 3a3.6 3.6 0 0 1 5.2 0l.8.9h1a3.6 3.6 0 0 1 3.7 3.6v1.1l.8.8a3.6 3.6 0 0 1 0 5.2l-.8.8v1a3.6 3.6 0 0 1-3.6 3.7h-1.1l-.8.8a3.6 3.6 0 0 1-5.2 0l-.8-.8h-1a3.6 3.6 0 0 1-3.7-3.6v-1.1l-.8-.8a3.6 3.6 0 0 1 0-5.2l.8-.8v-1a3.6 3.6 0 0 1 3.6-3.7h1.1zm1.4 12.8a1.3 1.3 0 1 0 2.5 0 1.3 1.3 0 0 0-2.5 0m2-2.6q-.1-.9 1-1.6 1.3-.8 1.3-2.4-.1-2.7-2.8-2.8-2 0-2.6 1.6l-.2.9q0 .7.7.8.4 0 .7-.7.3-1 1.3-1.1 1.3 0 1.3 1.3.1 1-1 1.7t-1.2 2v.2q0 .8.8.9.6 0 .7-.8"
    />
  </svg>
</template>
